import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ElementRef, ChangeDetectorRef} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { MasterService } from 'src/app/shared/services/master.service';
@Component({
  selector: 'app-snomed-model',
  templateUrl: './snomed-model.component.html',
  styleUrls: ['./snomed-model.component.css']
})
export class SnomedModelComponent implements OnInit {
  @Input() rData: any; 
  @Input() snoMedBeforeChecked: boolean =false; 
  @Input() snoemedList: any=[]; 
  @Output() conceptSelected = new EventEmitter<any>();  

semanticTags: any[] = [];
 currentPage: number = 1;
 pageSize: number = 25;   
 totalRecords: number = 0;
 selectedSemanticTags: string[] = [];
 pageSizes: number[] = [25, 50, 100];
 srchChiefComplts: any = ''; dtOptions: any = {}; dtRender: boolean = false; snomedLst: any = []; chiefComplaint: any='';
 loading: boolean = false;
 dtRender1 :boolean=false;
  isEnableJSKHealthCare: boolean=false;
  constructor(
    public actMdl: NgbActiveModal,
    private ngbMdl: NgbModal,
    public fb: FormBuilder,
    public router: Router,
    public http: HttpClient,
    private el: ElementRef, 
    private toastr: ToastrService,
    private registrationService: RegistrationService,
    private masterService: MasterService,
    private authServ: AuthenticationService,
    public changeDetection: ChangeDetectorRef,

  ) {}

  ngOnInit(): void {
    this.getFeaturePermission();
    this.srchChiefComplts = this.rData?.term;
    this.dtRender1 = true
    // this.snomedCTLst();
    this.dataTbls()
  }
    getFeaturePermission() {
      var featureList: any = JSON.parse(localStorage.getItem('featuresList')) || [];
      for (let i = 0; i < featureList.length; i++) {
        if (featureList[i].feature_id.feature_name == "EnableJSKHealthCare") {
          this.isEnableJSKHealthCare = featureList[i].patient;
        }
      }
  }

   dataTbls() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 25,
      processing: true,
      dom: '<"row mb-2"<"col-sm-6"l><"col-sm-6 text-end"f>>' + 
       'rt' + 
       '<"row mt-2"<"col-sm-6"i><"col-sm-6 text-end"p>>',
      buttons: [
        {
          extend: 'excelHtml5',
          text: '<i class="fa fa-file-excel-o"></i> Export Excel',
          filename: `DoctorRevenue`,
          title: ''
        },
      ]
    }
  }



   get totalPages(): number {
    return Math.ceil(this.snomedLst.length / this.pageSize);
  }

  get pagedSnomedList(): any[] {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.snomedLst.slice(start, start + this.pageSize);
  }

  onSemanticTagChange(tag: any, event: any) {
    tag.isChecked = event.target.checked;
    this.selectedSemanticTags = this.semanticTags
      .filter(t => t.isChecked)
      .map(t => t.name);

    this.currentPage = 1;
    this.snomedCTLst();
  }

  onPageSizeChange() {
    this.currentPage = 1;
  }

  goToPage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
  }

  async snomedCTLst() {
    if (this.srchChiefComplts.length > 2 || this.srchChiefComplts.length === 0) {
    

      // Build URL without limit (fetch max records)
      let url = `https://browser.ihtsdotools.org/snowstorm/snomed-ct/browser/MAIN/2025-09-01/descriptions?limit=1000&term=${this.srchChiefComplts}&active=true&conceptActive=true&lang=english&groupByConcept=true`;

      if (this.selectedSemanticTags.length) {
        url += `&semanticTags=${this.selectedSemanticTags.map(t => encodeURIComponent(t)).join('&semanticTags=')}`;
      } else {
        url += `&semanticTags=assessment%20scale&semanticTags=disorder`;
      }

  
       
         let response;
    response = await fetch(
      `${url}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      }
    );

    const res = await response.json();
    this.snoMedBeforeChecked = true;
     this.snomedLst = res?.items?.map((e: any) => ({ ...e, isChkd: false })) || [];

        // Initialize semantic tags only on first load
        if (!this.semanticTags.length) {
          this.semanticTags = Object.entries(res?.buckets?.semanticTags || {}).map(
            ([key, value]) => ({ name: key, count: value, isChecked: false })
          );
        } else {
          // Update counts without changing checkbox states
          const tagCounts = Object.entries(res?.buckets?.semanticTags || {});
          this.semanticTags = this.semanticTags.map(tag => {
            const match = tagCounts.find(([key]) => key === tag.name);
            return { ...tag, count: match ? match[1] : tag.count };
          });
        }

   
    }
  }

  // onConceptClick(conceptId: string,g:any) {
  //   if (!conceptId) return;
  //   this.loading = true;
  //   localStorage.setItem('selectedConcept',JSON.stringify(g));
  //   window.dispatchEvent(new Event('storage'));
     
  //   this.http
  //     .get<any>(
  //       `https://browser.ihtsdotools.org/snowstorm/snomed-ct/MAIN/2025-09-01/members?referencedComponentId=${conceptId}&active=true`
  //     )
  //     .subscribe(
  //       res => {
  //         const items = res?.items || [];
  //         const mapping = items.find((x: any) => x.additionalFields?.mapTarget);

  //         if (mapping) {
  //           const refsetId = mapping.refsetId;
  //           const mapTarget = mapping.additionalFields.mapTarget;

  //           this.http
  //             .get<any>(
  //               `https://browser.ihtsdotools.org/snowstorm/snomed-ct/MAIN/2025-09-01/concepts/${refsetId}`
  //             )
  //             .subscribe(
  //               refsetData => {
  //                 this.loading = false;

  //                 const result = {
  //                   mapRefsetName: refsetData.pt?.term,
  //                   mapTarget: mapTarget
  //                 };

  //                 this.passSelectedConcept(result);
  //               },
  //               _ => (this.loading = false)
  //             );
  //         } else {
  //           this.loading = false;
  //         }
  //       },
  //       _ => (this.loading = false)
  //     );
  // }

  async onConceptClick(conceptId: string, g: any) {

  if (!conceptId) return;

  this.loading = true;

  try {

    localStorage.setItem('selectedConcept', JSON.stringify(g));
    window.dispatchEvent(new Event('storage'));

    let response = await fetch(
      `https://browser.ihtsdotools.org/snowstorm/snomed-ct/MAIN/2025-09-01/members?referencedComponentId=${conceptId}&active=true`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    const res = await response.json();

    const items = res?.items || [];
    const mapping = items.find((x: any) => x.additionalFields?.mapTarget);

    if (mapping) {

      const refsetId = mapping.refsetId;
      const mapTarget = mapping.additionalFields.mapTarget;

      let refResponse = await fetch(
        `https://browser.ihtsdotools.org/snowstorm/snomed-ct/MAIN/2025-09-01/concepts/${refsetId}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      const refsetData = await refResponse.json();

      const result = {
        // mapRefsetName: refsetData?.pt?.term,
        // mapTarget: mapTarget
        ct_name: g?.term,
        ct_code: conceptId
      };

      this.passSelectedConcept(result);

    }

  } catch (error) {
    console.error('SNOMED Concept Error:', error);
  }

  this.loading = false;

}

  passSelectedConcept(data: any) {
  this.actMdl.close(data);  
  // this.snoMedBeforeChecked = false; 
}

checkedItem(item:any){
  this.rData = item
   this.srchChiefComplts = this.rData?.term;
   if(this.isEnableJSKHealthCare){
    this.snomedCTLst();
   }else{
    const result = {
        ct_name: item?.term,
        ct_code: item?.conceptId
      };

      this.passSelectedConcept(result);
   }

  

}
// close(){
//   this.actMdl.close(this.data); 
// }

}


